import {
  getAllEntrances,
  getAllGrad,
  getAllAnnualIncome,
  getDialogIndustry,
  getDialogOccupation,
  getDialogPref,
  getAllIndustry,
  getAllJobDsc,
  getAllAllowance,
  getAllInhabitType,
  getAllLanguageLevel,
  getAllLicenses,
  getAllLicensesByName,
  getAllLstschl,
  getAllOtrlang,
  getAllSchlByName,
  getAllSex,
  getAllOccupation3,
  getAllOvertimeHours,
  getAllPref,
  getAllRailwayStationByName,
  getAllRemoteWork,
  getAllSideJob,
  getAllStation,
  getAllWalkBus,
  getAllWkStatus,
  getAllWorkCnd,
  getAllEmpType,
  getLicensesNameById,
  getAllListed,
  getAllPeopleManagement,
  getAllPeopleManagementYear,
  getSchlNameById,
  getOccupationById,
  getRailwayStationNameById,
  getAllYearCategory,
  getAllApply,
  getAllFailure,
  getAllCity,
  getAllSchl,
  getAllChangeaddr,
  getAllEmployee,
  getAllJobchangetime,
  getAllSelectionPhase,
  getAllAspiration,
  getAllCourse,
  getAllPurpoSeagent,
} from '@/api/mstMyPageEndPoint';
import {
  DialogIndustryResponseDetail,
  DialogOccupResponseDetail,
  DialogPrefResponseDetail,
  MstMyPageItem,
  MstOccupation3,
} from '@/types/mstMyPage';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
const storeBase = MYPAGE_CONSTANTS.STORE_MST;

export const getAllAnnualIncomeService = async () => {
  try {
    const response = await getAllAnnualIncome();
    if (response.detail) {
      const mstAnualSlry = response.detail.map((inc: { anualslryid: number; anualslryname: string; anualslryvalue: any }) => ({
        id: inc.anualslryid,
        text: inc.anualslryname,
        value: inc.anualslryvalue,
      }));
      return mstAnualSlry as MstMyPageItem[];
    }
    return [] as MstMyPageItem[];
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllOvertimeHoursService = async () => {
  try {
    const response = await getAllOvertimeHours();
    if (response.detail) {
      return response.detail.map((inc: { overtimeid: number; overtimename: string; disporder: any }) => ({
        id: inc.overtimeid,
        text: inc.overtimename,
        value: inc.overtimeid,
      })) as MstMyPageItem[];
    }
    return [] as MstMyPageItem[];
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllRemoteWorkService = async () => {
  try {
    const response = await getAllRemoteWork();
    if (response.detail) {
      return response.detail.map((inc: { remoteworkid: number; remoteworkname: string; disporder: any }) => ({
        id: inc.remoteworkid,
        text: inc.remoteworkname,
        value: inc.remoteworkid,
      })) as MstMyPageItem[];
    }
    return [] as MstMyPageItem[];
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllSideJobService = async () => {
  try {
    const response = await getAllSideJob();
    if (response.detail) {
      return response.detail.map((inc: { sidebusinessid: number; sidebusinessname: string; disporder: any }) => ({
        id: inc.sidebusinessid,
        text: inc.sidebusinessname,
        value: inc.sidebusinessid,
      })) as MstMyPageItem[];
    }
    return [] as MstMyPageItem[];
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllWorkCndService = async () => {
  try {
    const response = await getAllWorkCnd();
    if (response.detail) {
      return response.detail.map((inc: { featuresid: number; featuresname: string; disporder: any }) => ({
        id: inc.featuresid,
        text: inc.featuresname,
        value: inc.featuresid,
        selected: false,
      })) as MstMyPageItem[];
    }
    return [] as MstMyPageItem[];
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllJobDscService = async () => {
  try {
    const response = await getAllJobDsc();
    if (response.detail) {
      return response.detail.map((inc: { featuresid: number; featuresname: string; disporder: any }) => ({
        id: inc.featuresid,
        text: inc.featuresname,
        value: inc.featuresid,
        selected: false,
      })) as MstMyPageItem[];
    }
    return [] as MstMyPageItem[];
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getDialogOccupationService = async () => {
  try {
    const response = await getDialogOccupation();
    const fetchedOccupDetail = response.detail as DialogOccupResponseDetail;
    return fetchedOccupDetail;
  } catch (err) {
    return {} as DialogOccupResponseDetail;
  }
};

export const getOccupationByIdService = async (id: string) => {
  try {
    const response = await getOccupationById(id);
    return response.detail as MstOccupation3;
  } catch (err) {
    return {} as MstOccupation3;
  }
};

export const getAllOccupation3Service = async () => {
  try {
    const response = await getAllOccupation3();
    return response.detail as MstOccupation3[];
  } catch (err) {
    return [] as MstOccupation3[];
  }
};

export const getDialogPrefService = async () => {
  try {
    const response = await getDialogPref();
    const fetchedPrefDetail = response.detail as DialogPrefResponseDetail;
    return fetchedPrefDetail;
  } catch (err) {
    return {} as DialogPrefResponseDetail;
  }
};

export const getDialogIndustryService = async () => {
  try {
    const response = await getDialogIndustry();
    const fetchedIndustryDetail = response.detail as DialogIndustryResponseDetail;

    return fetchedIndustryDetail;
  } catch (err) {
    return {} as DialogIndustryResponseDetail;
  }
};

export const getAllIndustryService = async () => {
  try {
    const response = await getAllIndustry();
    const fetchedData = response.detail.map((p: { indsctgid: number; indsctgname: string }) => ({
      id: p.indsctgid,
      text: p.indsctgname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllEmpTypeService = async () => {
  try {
    const response = await getAllEmpType();
    const fetchedData = response.detail.map((p: { emptypeid: number; emptypename: string }) => ({
      id: p.emptypeid,
      text: p.emptypename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllWalkBusService = async () => {
  try {
    const response = await getAllWalkBus();
    const fetchedData = response.detail.map((p: { mstwalkbusid: number; mstwalkbusname: string }) => ({
      id: p.mstwalkbusid,
      text: p.mstwalkbusname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllStationService = async () => {
  try {
    const response = await getAllStation();
    const fetchedData = response.detail.map((p: { stationid: number; stationname: string }) => ({
      id: p.stationid,
      text: p.stationname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllPrefService = async () => {
  try {
    const response = await getAllPref();
    const fetchedData = response.detail.map((p: { prefid: number; prefname: string }) => ({
      id: p.prefid,
      text: p.prefname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllCityService = async () => {
  try {
    const response = await getAllCity();
    const fetchedData = response.detail.map((p: { cityid: number; cityname: string }) => ({
      id: p.cityid,
      text: p.cityname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllChangeaddrService = async () => {
  try {
    const response = await getAllChangeaddr();
    const fetchedData = response.detail.map((p: { changeaddrid: number; changeaddrname: string }) => ({
      id: p.changeaddrid,
      text: p.changeaddrname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllEmployeeService = async () => {
  try {
    const response = await getAllEmployee();
    const fetchedData = response.detail.map((p: { employeeid: number; employeename: string }) => ({
      id: p.employeeid,
      text: p.employeename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllJobchangetimeService = async () => {
  try {
    const response = await getAllJobchangetime();
    const fetchedData = response.detail.map((p: { jobchangetimeid: number; jobchangetimename: string }) => ({
      id: p.jobchangetimeid,
      text: p.jobchangetimename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllSelectionPhaseService = async () => {
  try {
    const response = await getAllSelectionPhase();
    const fetchedData = response.detail.map((p: { selectionphaseid: number; selectionphasename: string }) => ({
      id: p.selectionphaseid,
      text: p.selectionphasename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllAspirationService = async () => {
  try {
    const response = await getAllAspiration();
    const fetchedData = response.detail.map((p: { aspirationid: number; aspirationname: string }) => ({
      id: p.aspirationid,
      text: p.aspirationname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllCourseService = async () => {
  try {
    const response = await getAllCourse();
    const fetchedData = response.detail.map((p: { courseid: number; coursename: string }) => ({
      id: p.courseid,
      text: p.coursename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllPurpoSeagentService = async () => {
  try {
    const response = await getAllPurpoSeagent();
    const fetchedData = response.detail.map((p: { purposeagentid: number; purposeagentname: string }) => ({
      id: p.purposeagentid,
      text: p.purposeagentname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllEntrancesService = async () => {
  try {
    const response = await getAllEntrances();
    const fetchedData = response.detail.map((p: { entranceid: number; entrancename: string }) => ({
      id: p.entranceid,
      text: p.entrancename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllGradService = async () => {
  try {
    const response = await getAllGrad();
    const fetchedData = response.detail.map((p: { gradid: number; gradname: string }) => ({
      id: p.gradid,
      text: p.gradname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllLstschlService = async () => {
  try {
    const response = await getAllLstschl();
    const fetchedData = response.detail.map((p: { lstschlid: number; lstschlname: string }) => ({
      id: p.lstschlid,
      text: p.lstschlname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllOtrlangService = async () => {
  try {
    const response = await getAllOtrlang();
    const fetchedData = response.detail.map((p: { otrlangid: number; otrlangname: string }) => ({
      id: p.otrlangid,
      text: p.otrlangname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllLanguageLevelService = async () => {
  try {
    const response = await getAllLanguageLevel();
    const fetchedData = response.detail.map((p: { languagelevelid: number; languagelevelname: string }) => ({
      id: p.languagelevelid,
      text: p.languagelevelname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllLicenseService = async () => {
  try {
    const response = await getAllLicenses();
    const fetchedData = response.detail.map((p: { licenseid: number; licensename: string }) => ({
      id: p.licenseid,
      text: p.licensename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllSexService = async () => {
  try {
    const response = await getAllSex();
    const fetchedData = response.detail.map((p: { sexid: number; sexname: string }) => ({
      id: p.sexid,
      text: p.sexname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllInhabitTypeService = async () => {
  try {
    const response = await getAllInhabitType();
    const fetchedData = response.detail.map((p: { inhabittypeid: number; inhabittypename: string }) => ({
      id: p.inhabittypeid,
      text: p.inhabittypename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllAllowanceService = async () => {
  try {
    const response = await getAllAllowance();
    const fetchedData = response.detail.map((p: { allowanceid: number; allowancename: string }) => ({
      id: p.allowanceid,
      text: p.allowancename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllWkStatusService = async () => {
  try {
    const response = await getAllWkStatus();
    const fetchedData = response.detail.map((p: { wkstatusid: number; wkstatusname: string }) => ({
      id: p.wkstatusid,
      text: p.wkstatusname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllLicenseByNameService = async (name: string) => {
  try {
    const response = await getAllLicensesByName(name);
    const fetchedData = response.detail.map((p: { licenseid: number; licensename: string }) => ({
      id: p.licenseid,
      text: p.licensename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getLicenseNameByIdService = async (id: string) => {
  try {
    const response = await getLicensesNameById(id);
    const fetchedData = response.detail as string;
    return fetchedData;
  } catch (err) {
    return '';
  }
};

export const getAllStationByNameService = async (name: string) => {
  try {
    const response = await getAllRailwayStationByName(name);
    const fetchedData = response.detail.map((p: { stationId: number; stationName: string; railwayNames: string[] }) => ({
      id: p.stationId,
      text: p.stationName + (p.railwayNames.length ? `（${p.railwayNames.join('／')}）` : ''),
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [];
  }
};

export const getStationNameByIdService = async (stationId: string) => {
  try {
    const response = await getRailwayStationNameById(stationId);
    const fetchedData = response.detail;
    const stationName = fetchedData.stationName + (fetchedData.railwayNames.length ? `（${fetchedData.railwayNames.join('／')}）` : '');
    return stationName;
  } catch (err) {
    return '';
  }
};

export const getAllschlByNameService = async (name: string) => {
  try {
    const response = await getAllSchlByName(name);
    const fetchedData = response.detail.map((p: { schlid: number; schlname: string }) => ({
      id: p.schlid,
      text: p.schlname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllSchoolService = async () => {
  try {
    const response = await getAllSchl();
    const fetchedData = response.detail.map((p: { schlid: number; schlname: string }) => ({
      id: p.schlid,
      text: p.schlname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getSchlNameByIdService = async (id: string) => {
  try {
    const response = await getSchlNameById(id);
    const stationName = response.detail;
    return stationName;
  } catch (err) {
    return '';
  }
};

export const getAllPeopleManagementService = async () => {
  try {
    const response = await getAllPeopleManagement();
    const fetchedData = response.detail.map((p: { peoplecategoryid: number; peoplecategoryname: string }) => ({
      id: p.peoplecategoryid,
      text: p.peoplecategoryname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllPeopleManagementYearService = async () => {
  try {
    const response = await getAllPeopleManagementYear();
    const fetchedData = response.detail.map((p: { managementyearcategoryid: number; managementyearcategoryname: string }) => ({
      id: p.managementyearcategoryid,
      text: p.managementyearcategoryname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllListedService = async () => {
  try {
    const response = await getAllListed();
    const fetchedData = response.detail.map((p: { listedid: number; listedname: string }) => ({
      id: p.listedid,
      text: p.listedname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllYearCategoryService = async () => {
  try {
    const response = await getAllYearCategory();
    const fetchedData = response.detail.map((p: { yearcategoryid: number; yearcategoryname: string }) => ({
      id: p.yearcategoryid,
      text: p.yearcategoryname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllApplyService = async () => {
  try {
    const response = await getAllApply();
    const fetchedData = response.detail.map((p: { applyid: number; applyname: string }) => ({
      id: p.applyid,
      text: p.applyname,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getAllFailureService = async () => {
  try {
    const response = await getAllFailure();
    const fetchedData = response.detail.map((p: { failureid: number; failurename: string }) => ({
      id: p.failureid,
      text: p.failurename,
    })) as MstMyPageItem[];
    return fetchedData;
  } catch (err) {
    return [] as MstMyPageItem[];
  }
};

export const getMstNameByIdService = async (id:number|string, storeName: string, store: any) =>{
  const data = await store.dispatch(storeName);
  if(storeName == storeBase.MST_OCUP3) {
    return data.find((item: { ocupctgid: string; ocup3classname: string }) => item.ocupctgid == id)?.ocup3classname || '';
  }
  else {
      return data.find((item: { id: number|string; text: string }) => item.id == id)?.text || '';
  }
};